// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DeletedComment_wrapper__3CdIP","comment":"DeletedComment_comment__2cB3p","text":"DeletedComment_text__1dkIH","button":"DeletedComment_button__wzy8R"};